import { ResourcesManager, EventDispatcher } from '@verybigthings/vbt-webvr-framework';
import './index.scss';
export default class ChangeModeModalClass extends EventDispatcher {
    constructor() {
        super();
        const wrapper = document.getElementById('threeJS');
        this.changeModeModal = document.createElement('div');
        this.changeModeModal.classList.add('change-mode-modal');
        this.changeModeModal.classList.add('hide');
        this.changeModeModal.style.backgroundImage = `url(${ResourcesManager.getTexture('popup_decoration_short').image.currentSrc})`;
        this.changeModeModal.innerHTML = `
            <div class="change-mode-modal-header">Switch to <span class="mode-name">zSpace</span> mode</div>
            <div class="change-mode-modal-text">Are you sure you want to go to <span class="mode-name">zSpace</span> mode? Progress on incomplete levels will not be saved.</div>
            <div class="change-mode-modal-wrap-buttons">
                 <button id="change-mode-modal-ok">OK</button> <button id="change-mode-modal-cancel" class="btn-second">CANCEL</button>
            </div>
        `;
        wrapper.appendChild(this.changeModeModal);
        setTimeout(() => {
            const buttonOk = document.getElementById('change-mode-modal-ok');
            const buttonCancel = document.getElementById('change-mode-modal-cancel');
            buttonOk.addEventListener('click', () => {
                this.hide();
                this.fire('ok');
            });
            buttonCancel.addEventListener('click', () => {
                console.log('buttonCancel.addEventListener');
                this.hide();
                this.fire('cancel');
            });
        });
    }
    setModeName(modeName) {
        const modeNameListHTML = document.querySelectorAll('.change-mode-modal .mode-name');
        Array.from(modeNameListHTML).forEach(modeNameHTML => modeNameHTML.innerText = modeName);
    }
    show() {
        this.changeModeModal.classList.remove('hide');
    }
    hide() {
        this.changeModeModal.classList.add('hide');
    }
}
